import Immutable from "immutable";

const BasketItem = new Immutable.Record({
  basketItemID: undefined,
  groupID: undefined,
  studentID: undefined,
  schoolID: undefined,
  type: undefined,
  price: undefined,
  quantity: undefined,
  payload: new Immutable.Map()
}, "Basket Item");

function buildBasketItemFromAction({ payload }) {
  return BasketItem({
    basketItemID: payload.basketItemID,
    groupID: payload.groupID,
    studentID: payload.studentID,
    schoolID: payload.schoolID,
    type: payload.type,
    price: payload.price,
    quantity: payload.quantity,
    payload: new Immutable.Map(payload.payload)
  });
}

BasketItem.fromAction = buildBasketItemFromAction;
export default BasketItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/BasketItem.js